<h2 class="title">Guida all'utilizzo del software</h2>

<div fxLayout="row" class="mb controlsbar" [ngClass.xs]="{ mobile: true }">
  <button (click)="incrementZoom(-0.5)" mat-button type="button">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      <line x1="8" y1="11" x2="14" y2="11"></line>
    </svg>
  </button>

  <button (click)="incrementZoom(0.5)" mat-button type="button">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      <line x1="11" y1="8" x2="11" y2="14"></line>
      <line x1="8" y1="11" x2="14" y2="11"></line>
    </svg>
  </button>
</div>

<div
  fxFlex
  fxLayout="column"
  id="outerContainer wrapper"
  [ngClass.xs]="{ mobile: true }"
>
  <div
    fxFlex
    fxLayout="column"
    class="pdf-container wrapper"
    [ngClass.xs]="{ mobile: true }"
  >
    <pdf-viewer
      [src]="src"
      [rotation]="0"
      [original-size]="false"
      [show-all]="true"
      [fit-to-page]="true"
      [zoom]="zoom"
      [zoom-scale]="'page-width'"
      [stick-to-page]="false"
      [render-text]="true"
      [external-link-target]="'blank'"
      [autoresize]="true"
      [show-borders]="false"
      class="wrapper"
      [ngClass.xs]="{ mobile: true }"
    ></pdf-viewer>
  </div>
</div>
